/**
 * Close Drawer Action
 * Uses the existing runToggleDrawer with action='hide' and unique event ID targeting
 */

import { runDrawerToggle } from './runDrawerToggle.jsx';

export const runDrawerClose = async (data = {}) => {
  try {
    const { eventId, targetEventId, ...otherData } = data;

    // Use targetEventId as selector if provided, otherwise use eventId
    const selector = targetEventId ? `#${targetEventId}` : eventId ? `#${eventId}` : '#details-drawer';

    return await runDrawerToggle({
      action: 'hide',
      selector,
      ...otherData
    });
  } catch (error) {
    console.error('Close drawer error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runDrawerClose;
